/**
 * Which brand the UI is currently working in.
 *
 * One source of truth, shared by the topbar that sets it and the screens that
 * read it. Before this, the knowledge base and analysis pages each carried
 * their own brand dropdown while the topbar carried a third — three controls
 * that could disagree, on data where disagreeing means editing the wrong
 * client's FAQ.
 *
 * The value is a convenience, never a permission: the server reads X-Tenant-Id
 * only for users whose own tenant_id is null (see App\Support\TenantContext),
 * so changing it by hand gets a scoped agent nothing.
 */
const KEY = 'inbox_tenant_id'

export const tenantHelper = {
  /** The selected brand, or null = "all brands" (platform staff only). */
  current() {
    const v = localStorage.getItem(KEY)
    return v ? Number(v) : null
  },
  set(tenantId) {
    if (tenantId === null || tenantId === undefined) localStorage.removeItem(KEY)
    else localStorage.setItem(KEY, String(tenantId))
  },
  key: KEY,
}
